import React, { Component, PropType } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { removeFilter, set_property_metric_breakup, remove_property_metric_breakup, get_property_metric_breakup, set_disp_objects, setTableActions, handle_transpose_table, saveFilterToggleHandle, toggleOldFilter } from '../../actions/index'
import { ButtonComponent } from './UIComponent'
import Formv2 from '../../../adminpanel/components/commonComponents/Form.v2'
import ModalComponent from '../../../adminpanel/components/commonComponents/ModalComponent';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { DBService } from '../SummaryComponents/component/IndexedDB'

var textMarginTop = { marginTop: '10px' };
var textMarginBottom = { marginTop: '-6px' };

var toolTipCSS = { display: 'inline-block ! important', color: 'black ! important', padding: '0px', paddingLeft: '5px', cursor: 'auto' };
var $SelectedBreakUpDisp = null, $propertyDisp = null, $handleChange = null, $metricFunction = {}, $filterHandleChange = null, $current_page = null, $includeDisp = null, $excludeDisp = null;
var selectedMetricDisp;
var selectedMetricWithRangeGlobel = [], chartToSwitch = [];

var filterArray = ["metric", "property", "breakup", "include", "exclude", "timeGran", "outputType", "sortOrder", "limit"];
var metricMulti = false, propMulti = false;
var metricToggleIndex = 0;
var propertyToggleIndex = 0;
var filterData = { "selectedMetric": "", "property": "", "breakup": "", "timeGran": "", "sortOrder": "", "limit": "", "clicked": "", "include": "", "exclude": "" }

var formattingFormObject = { 'rangeBased': [], 'comparison': [], 'compareMultiple': [] }, selectedMetricValue = null

class FilterComponent extends React.Component {
    constructor(props) {
        super(props);
        var pageName = window.location.pathname.split('/');
        pageName = pageName[1];
        if (dataLabels != '1') {
            this.state = {
                dataLabelsButton: "Add Data Labels",
                insightEnable: false,
                property_multi: false,
                crosstab_flag: false,
                metric_multi: false,
                pageName: pageName,
                filterTagsToHandle: null
            }
        } else {
            this.state = {
                dataLabelsButton: "Remove Data Labels",
                insightEnable: false,
                property_multi: false,
                crosstab_flag: false,
                metric_multi: false,
                pageName: pageName,
                filterTagsToHandle: null
            }
        }
        this.state['condFormatModalTitle'] = ''
        this.state['formattingForm'] = formattingFormObject
        this.formattingFormData = {
            'compareParam': {
                name: 'compareParam', label: 'Metric to compare', type: 'hide', options: [], requiredFlag: false
            },
            'operator': {
                name: 'operator', label: 'Format Rules', type: 'dropdown', options: [{ name: 'Greater than', value: '>' }, { name: 'Greater than or equal to', value: '>=' }, { name: 'Less than', value: '<' }, { name: 'Less than or equal to', value: '<=' }, { name: 'Equal to', value: '=' }, { name: 'Not equal to', value: '!=' }, { name: 'Between', value: '<>' }], requiredFlag: true
            },
            'value': {
                name: 'value', label: 'Value', type: 'number', requiredFlag: true
            },
            'value2': {
                name: 'value2', label: 'Value', type: 'hide'
            },
            'color': {
                name: 'color', label: 'Format Color', type: 'color', requiredFlag: true
            },
            'deleteRule': {
                name: 'deleteRule', label: '', type: 'iconButton', icon: 'trash'
            }
        }
        this._db = new DBService();
        this.metricContext = this.metricContext.bind(this);
        this.replaceWordWithFunction = this.replaceWordWithFunction.bind(this);
        this.changeDispObject = this.changeDispObject.bind(this);
        this.toggleIndex = this.toggleIndex.bind(this);
        this.handleFilterToggle = this.handleFilterToggle.bind(this);
        this.oldFilterToggle = this.oldFilterToggle.bind(this);
        this.handleApplyFilters = this.handleApplyFilters.bind(this)
        this.handleFormattingModal = this.handleFormattingModal.bind(this)
        this.handleAddRule = this.handleAddRule.bind(this)
        this.handleDeleteRule = this.handleDeleteRule.bind(this)
        this.onChangeHandle = this.onChangeHandle.bind(this)
        this.handleSyncClick = this.handleSyncClick.bind(this);
    }
    componentDidMount() {
        $metricFunction = this.props.metricFunction;
        selectedMetricDisp = this.props.selectedMetricDisp;
        jQuery('[data-toggle="tooltip"]').tooltip();
        this.filterValuesToShow(this.props);
        $propertyDisp = this.props.propertyDisp;
        this.tagsDefining();
    }
    componentWillReceiveProps(nextProps) {
        this.customComponentWillReceiveProps(nextProps, this.props);
        // $SelectedBreakUpDisp = nextProps.SelectedBreakUpDisp;
        // $propertyDisp = nextProps.propertyDisp;
        // selectedMetricDisp = nextProps.selectedMetricDisp;
        // this.metricContext($metricFunction, $handleChange);
        // if (dataLabels != '1')
        //     var dataLabelsButton = "Add Data Labels";
        // else var dataLabelsButton = "Remove Data Labels";
        // this.setState({dataLabelsButton: dataLabelsButton, pageName: nextProps.pageName, dashboardConfigDates: nextProps.dashboardConfigDates });
        // this.filterValuesToShow(nextProps, this.props);
    }
    customComponentWillReceiveProps(nextProps, thisProps) {
        $SelectedBreakUpDisp = nextProps.SelectedBreakUpDisp;
        $propertyDisp = nextProps.propertyDisp;
        selectedMetricDisp = nextProps.selectedMetricDisp;
        this.metricContext($metricFunction, $handleChange);
        if (dataLabels != '1')
            var dataLabelsButton = "Add Data Labels";
        else var dataLabelsButton = "Remove Data Labels";
        this.setState({ dataLabelsButton: dataLabelsButton, pageName: nextProps.pageName, dashboardConfigDates: nextProps.dashboardConfigDates, filterTagsToHandle: null });
        this.filterValuesToShow(nextProps, thisProps);
    }
    componentDidUpdate() {
        feather.replace();
    }
    metricContext(metricFunction, handleChange) {
        var $temp_metricFunction = {};
        var that = this;
        if (metricFunction) {
            metricFunction = typeof (metricFunction) == "object" ? Object.values(metricFunction) : metricFunction
            metricFunction.map(function (innerData) {
                if (innerData.value) {

                    if ($temp_metricFunction[innerData.metricGroup])
                        $temp_metricFunction[innerData.metricGroup]['items'][innerData.value] = innerData;
                    else {
                        $temp_metricFunction[innerData.metricGroup] = { "name": innerData.metricGroup, "items": {} };
                        $temp_metricFunction[innerData.metricGroup]['items'][innerData.value] = innerData;
                    }
                    // $temp_metricFunction[innerData.value] = innerData
                }
            })

            if ($temp_metricFunction) {
                jQuery(function () {
                    jQuery.contextMenu({
                        selector: '.contextAllow',
                        callback: function (key, options) {
                            key = options.commands[key].value;
                            // key = $temp_metricFunction[key].value;
                            that.replaceWordWithFunction(this[0].innerText, key, selectedMetricDisp, $handleChange);
                            // var m = "clicked: " + key;
                            // window.console && console.log(m) || alert(m);
                        },
                        items: $temp_metricFunction
                    });
                    if ($temp_metricFunction.percentile) {
                        jQuery.contextMenu({
                            selector: '.noContext',
                            callback: function (key, options) {
                                key = options.commands[key].value;
                                // key = $temp_metricFunction[key].value;
                                that.replaceWordWithFunction(this[0].innerText, key, selectedMetricDisp, $handleChange);
                                // var m = "clicked: " + key;
                                // window.console && console.log(m) || alert(m);
                            },
                            items: { "": { "name": "Default", "value": "" }, "percentile": { "name": "Percentile", "value": "percentile" } }
                        });
                    }
                });
            }
        }
    }
    replaceWordWithFunction(text, functionName, selectedMetricDisp, $handleChange) {
        $handleChange = this.state.pageName == "dashboard" ? this.props.propertyHandle : this.props.handleChange;
        var finalFunction = null;
        var that = this;
        metricFunction = typeof (metricFunction) == "object" ? Object.values(metricFunction) : metricFunction
        metricFunction.map(function (innerData) {
            if (innerData.value === functionName) {
                finalFunction = innerData;
            }
        })

        var finalMetricArray = JSON.parse(JSON.stringify(selectedMetricDisp));
        selectedMetricDisp.map(function (innerData) {
            if (innerData.label === text) {
                that.changeDispObject(innerData, metricFunction, finalFunction);
                if(finalFunction?.value.includes('cagr')){
                    alert("Only one CAGR metric allowed!")
                    finalMetricArray = []
                }
            
         finalMetricArray.push(innerData);
            }
        })
        var nextProps = { ...this.state }
        if (filterData.clicked !== "") {
            filterData.selectedMetric = finalMetricArray.map(a => a.value).toString()
            filterData.selectedMetricDisp = finalMetricArray
            if ((filterData.clicked).includes('metric') === false)
                filterData.clicked = `${filterData.clicked},metric`;
        } else filterData = { ...filterData, "selectedMetric": finalMetricArray.map(a => a.value).toString(), "selectedMetricDisp": finalMetricArray, "property": this.props.property, "breakup": this.props.breakup, "timeGran": this.state.period, "clicked": 'metric' }

        nextProps = { ...nextProps, 'selectedMetric': finalMetricArray.map(a => a.value).toString(), 'selectedMetricDisp': finalMetricArray }
        this.setState({ ...this.state, filterData });
        this.customComponentWillReceiveProps(nextProps, this.props);

        // $handleChange('metric', finalMetricArray);
    }
    changeDispObject(rightClickMetric, functionsArray, metricToReplace) {
        var $done = false;

        /* checked rightClickMetric.value.split(';')[1] == "" - it was giving error when we add meta kpi from already selected meta kpi - was appending label and values */
        if (rightClickMetric.isDerived == 2 && rightClickMetric.defaultFormula == "" && rightClickMetric.value && rightClickMetric.value.split(';')[1] == "") {
            rightClickMetric.label = `${metricToReplace.name} ${rightClickMetric.label}`;
            rightClickMetric.value = `${rightClickMetric.value}${metricToReplace.value}`;
        }
        else {
            functionsArray.map(function (innerData) {
                if (innerData.value && !$done) {
                    if (rightClickMetric.value.search('\\b' + innerData.value + '\\b') > -1) {
                        if (rightClickMetric.defaultFormula == metricToReplace.value)
                            rightClickMetric.label = (rightClickMetric.label.replace(innerData.name, "")).trim();
                        else if (innerData.value == rightClickMetric.defaultFormula)
                            rightClickMetric.label = (metricToReplace.name + " " + rightClickMetric.label).trim();
                        else rightClickMetric.label = rightClickMetric.label.replace(innerData.name, metricToReplace.name);
                        rightClickMetric.value = rightClickMetric.value.replace(new RegExp("\\b" + innerData.value + "\\b"), metricToReplace.value);
                        $done = true;
                    }
                } else if (metricToReplace.name == "Percentile" && !$done) {
                    if (rightClickMetric.value[rightClickMetric.value.length - 1] == ';') {
                        rightClickMetric.label = metricToReplace.name + " " + rightClickMetric.label;
                        rightClickMetric.value = rightClickMetric.value + "" + metricToReplace.value;
                        $done = true;
                    }
                }
            })
        }
        return rightClickMetric;
    }
    tagsDefining() {
        var that = this;
        $SelectedBreakUpDisp = this.props.SelectedBreakUpDisp;
        $includeDisp = this.props.includeDisp;
        $excludeDisp = this.props.excludeDisp;
        // Anurag Update on Total dimension
        // Below line commented by Anurag to handle Total Dimension
        // $propertyDisp = this.props.propertyDisp;
        selectedMetricDisp = selectedMetricDisp ? selectedMetricDisp : this.props.selectedMetricDisp;
        $current_page = this.state.pageName;
        $handleChange = this.state.pageName == "dashboard" ? this.props.propertyHandle : this.props.handleChange;
        $filterHandleChange = this.state.pageName == "dashboard" ? this.props.filterHandle : this.props.handleChange;
        var $filterHandleChange = that.props.filterHandleChange;
        this.metricContext($metricFunction, $handleChange);
        var elt = jQuery('#property-taginput');//property jquery multi tag initialize
        elt.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });//defining which object to be shown and taken as value
        var eltFilter = jQuery('#filter-taginput');//filter jquery multi tag initialize
        eltFilter.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });
        var eltExclude = jQuery('#exclude-taginput');//exlude jquery multi tag initialize
        eltExclude.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });
        var eltInclude = jQuery('#include-taginput');//include jquery multi tag initialize
        eltInclude.tagsinput({
            itemValue: 'value',
            itemText: 'label'
        });
        var eltMetric = jQuery('#metric-taginput');//filter jquery multi tag initialize
        eltMetric.tagsinput({
            itemValue: 'value',
            itemText: 'label',
            tagClass: function (item) {
                return 'label label-info contextAllow';
                // return (item.isDerived !== '2' ? 'label label-info contextAllow' : 'label label-info noContext');
            }
        });
        jQuery('#property-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            if ($propertyDisp) {
                if (!$propertyDisp.length) {//if object then convert into array
                    $propertyDisp = [$propertyDisp];
                }
                $propertyDisp.map(function (innerData, index) {//loop the array to find index
                    if (event.item.value == innerData.value) {
                        getIndex = index;
                    }
                });
            }
            if (getIndex >= 0) {
                $propertyDisp.splice(getIndex, 1);//splice the array to remove the object
                if ($propertyDisp.length == 0) {//if there is no property then send null
                    $propertyDisp = null;
                }
                // var temp_metric = selectedMetricDisp.map(a => a.value).toString();
                var temp_property = $propertyDisp ? $propertyDisp.map(a => a.value).toString() : "";
                // var temp_breakup = $SelectedBreakUpDisp.map(a => a.value).toString();
                temp_property = temp_property ? temp_property : "empty";
                $filterHandleChange({ "property": temp_property, clicked: 'property' })//pass to the final function
                // if ($current_page == "dashboard")
                //     $handleChange($propertyDisp);
                // else $handleChange('property', $propertyDisp);//pass to the final function
                that.refs.propertyFilter.loadOptions("");
            }
        });
        jQuery('#filter-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            $SelectedBreakUpDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                $SelectedBreakUpDisp.splice(getIndex, 1);//splice the array to remove the object

                var temp_metric = selectedMetricDisp.map(a => a.value).toString();
                var temp_property = $propertyDisp.map(a => a.value).toString();
                var temp_breakup = $SelectedBreakUpDisp.map(a => a.value).toString();
                temp_breakup = temp_breakup ? temp_breakup : "empty";
                $filterHandleChange({ "breakup": temp_breakup, clicked: 'filter' })//pass to the final function
            }
        });
        jQuery('#exclude-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            $excludeDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                $excludeDisp.splice(getIndex, 1);//splice the array to remove the object
                let tempExclude = $excludeDisp.map(a => a.value).toString()
                tempExclude = tempExclude ? tempExclude : "empty";
                $filterHandleChange({ 'exclude': tempExclude, clicked: 'exclude' });//pass to the final function
            }
        });
        jQuery('#include-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            $includeDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                $includeDisp.splice(getIndex, 1);//splice the array to remove the object
                let tempInclude = $includeDisp.map(a => a.value).toString()
                tempInclude = tempInclude ? tempInclude : "empty";
                $filterHandleChange({ 'include': tempInclude, clicked: 'include' });//pass to the final function
                // if($current_page=="dashboard")
                //     $filterHandleChange($includeDisp);
                // else $filterHandleChange('include', $includeDisp);//pass to the final function
            }
        });
        jQuery('#metric-taginput').on('itemRemoved', function (event) {
            var getIndex = -1;//getIndex of object
            selectedMetricDisp.map(function (innerData, index) {//loop the array to find index
                if (event.item.value == innerData.value) {
                    getIndex = index;
                }
            });
            if (getIndex >= 0) {
                selectedMetricDisp.splice(getIndex, 1);//splice the array to remove the object

                var temp_metric = selectedMetricDisp.map(a => a.value).toString();
                temp_metric = temp_metric ? temp_metric : "empty";
                $filterHandleChange({ "selectedMetric": temp_metric, clicked: 'metric' })//pass to the final function
                // $handleChange('metric', selectedMetricDisp);
            }
        });
    }

    handleSyncClick() {
        let indexedDB = this._db
        IDBStoreNames.forEach((e) => {
            if (this.props.datasetDetails.toolId) {
                indexedDB.deleteByToolId(e, this.props.datasetDetails.toolId);
            }
        })
        window.localStorage.setItem('redirectTo', JSON.stringify(location));
        handleChangeCalled = false;
        this.props.changeDataSet(this.props.datasetDetails.toolId);
    }

    onChangeHandle = (e, formattingType) => {
        let indexToChange = parseInt(e.target.id.split('_')[1])
        let tempFormObj = { ...this.state.formattingForm }
        let elementToChange = tempFormObj[formattingType][indexToChange]
        if (elementToChange[e.target.name].multiple) {
            elementToChange[e.target.name].text_value = $(`#${e.target.name}_${index}_form_data`).val();
        } else if (e.target.name == 'compareParam') {
            Object.values(tempFormObj[formattingType]).map(function (innerData) {
                if (innerData['compareParam']) {
                    innerData['compareParam']['text_value'] = e.target.value
                }
            })
        } else elementToChange[e.target.name].text_value = e.target.value
        if (formattingType === 'rangeBased' && e.target.name === 'operator') {
            if (e.target.value === '<>') {
                elementToChange['value2'].type = 'number'
                elementToChange['value2']['requiredFlag'] = true
            } else {
                elementToChange['value2'].type = 'hide'
                elementToChange['value2']['requiredFlag'] = false
            }
        }
        tempFormObj[formattingType][indexToChange] = elementToChange
        this.setState({ formattingForm: tempFormObj });
    }

    handleDeleteRule = (e, formattingType = null) => {
        e.preventDefault()
        let tempFormObj = { ...this.state.formattingForm }
        if (formattingType == null) {
            formattingType = e.target.id.split('_')[0]
            tempFormObj[formattingType] = []
        } else {
            let indexToRemove = parseInt(e.target.id.split('_')[1])
            tempFormObj[formattingType].splice(indexToRemove, 1)
        }
        tempFormObj[formattingType].length == 0 ? formattingFormObject[formattingType] = [] : null
        this.setState({ formattingForm: tempFormObj[formattingType].length > 0 ? tempFormObj : formattingFormObject });
    }

    handleAddRule = (e, tempFormObject = null) => {
        tempFormObject == null ? e.preventDefault() : null
        let formattingType = tempFormObject ? e : e.target.id.split('_')[0]
        let tempFormObj = tempFormObject ? { ...tempFormObject } : { ...this.state.formattingForm }
        let tempFormattingFormData = JSON.parse(JSON.stringify(this.formattingFormData))
        if (formattingType == 'comparison') {
            tempFormattingFormData['operator']['options'].splice(7, 1)
            tempFormattingFormData['compareParam']['type'] = 'dropdown'
            tempFormattingFormData['compareParam']['options'] = tempFormObj[formattingType][0].compareParam.options
            tempFormattingFormData['compareParam']['text_value'] = tempFormObj[formattingType][0].compareParam.text_value
            tempFormattingFormData['compareParam']['disabled'] = true
            tempFormattingFormData['value']['type'] = 'hide'
        } else if (formattingType == 'compareMultiple') {
            tempFormattingFormData['operator']['options'].splice(5, 3)
            tempFormattingFormData['compareParam']['type'] = 'dropdown'
            tempFormattingFormData['compareParam']['label'] = 'Metrics benchmark'
            tempFormattingFormData['compareParam']['text_value'] = tempFormObj[formattingType][0].compareParam.text_value
            tempFormattingFormData['compareParam']['disabled'] = true
            tempFormattingFormData['compareParam']['multiple'] = true
            // tempFormattingFormData['compareParam']['options'].shift()
            tempFormattingFormData['value']['type'] = 'hide'
        }
        tempFormattingFormData['deleteRule']['onClick'] = (e) => this.handleDeleteRule(e, formattingType)
        tempFormObj[formattingType].push(tempFormattingFormData)
        this.setState({ formattingForm: tempFormObj })
    }

    handleFormattingModal(e) {
        let that = this
        let metricValue = selectedMetricValue.split(';')[0]
        let modalTitle = capitalizeFirstChar(metricValue)
        let tempFormObj = { ...that.state.formattingForm }
        if (e == 'rangeBased') {
            that.props.Metric && that.props.Metric.map(function (innerData) {
                if (innerData.value == metricValue && innerData.information) {
                    let parsedInfo = JSON.parse(innerData.information)
                    if (parsedInfo && parsedInfo['range_based']) {
                        let info = parsedInfo['range_based'][innerData.defaultFormula]
                        info && Object.keys(info).map((key, value) => {
                            if (value >= tempFormObj[e].length) {
                                that.handleAddRule(e, tempFormObj)
                            }
                            let elementToChange = tempFormObj[e][value]
                            elementToChange && Object.values(elementToChange).map(function (innerElement) {
                                if (info[key]['value2']) {
                                    elementToChange['value2'].type = 'number'
                                }
                                elementToChange[innerElement.name].text_value = info[key][innerElement.name]
                            })
                        })
                    }
                }
            })
            that.setState({ ...that.state, formattingForm: tempFormObj, condFormatModalTitle: <>Range Based Formatting <span>({modalTitle})</span></> });
            jQuery('#rangeBasedModal').modal('toggle');
        } else if (e == 'comparison') {
            let metricDropdownOptions = [{ name: "Select Metric", value: "" }]
            that.props.Metric && that.props.Metric.map(function (innerData) {
                if (innerData.value != metricValue) {
                    metricDropdownOptions.push({ name: innerData.label, value: `${innerData.value};${innerData.defaultFormula}` })
                }
            })
            Object.values(tempFormObj[e]).map(function (innerElement) {
                if (innerElement['compareParam'] && innerElement['compareParam']['options'].length == 0) {
                    innerElement['compareParam']['options'] = metricDropdownOptions
                }
            })
            that.setState({ ...that.state, formattingForm: tempFormObj, condFormatModalTitle: <>Compare Based Formatting <span>({modalTitle})</span></> })
            jQuery('#comparisonModal').modal('toggle');
        } else if (e == 'compareMultiple') {
            jQuery('#compareMultipleModal').modal('toggle');
        } else if (['rangeBased_button', 'comparison_button', 'compareMultiple_button'].indexOf(e.target.id) > -1) {
            let target = e.target.id
            let formArray = null, rangeObj = null
            let postData = {
                'siteId': that.props.datasetDetails.siteId,
                'toolId': that.props.datasetDetails.toolId,
                'selectedMetric': selectedMetricValue,
                'rules': {}
            }
            let metricFuncVal = selectedMetricValue.split(';')[1], rangeCount = 0;

            if (target == 'rangeBased_button') {
                postData['rules']['range_based'] = {}
                rangeObj = postData['rules']['range_based'][metricFuncVal] = {}

                formArray = $('#rangeBasedForm').serializeArray()
            } else if (target == 'comparison_button') {
                postData['rules']['compare_based'] = {}
                rangeObj = postData['rules']['compare_based'][metricFuncVal] = {}

                formArray = $('#comparisonForm').serializeArray()
            } else if (target == 'compareMultiple_button') {
                postData['rules']['benchmark_based'] = {}
                rangeObj = postData['rules']['benchmark_based'][metricFuncVal] = {}

                formArray = $('#compareMultipleForm').serializeArray()
            }
            formArray.map(function (innerData) {
                if (innerData.value != "" && innerData.value != '#000000') {
                    if (innerData.name == 'operator') {
                        rangeCount = rangeCount + 1
                        rangeObj[`range${rangeCount}`] = {}
                    }
                    if (innerData.name == 'compareParam') {
                        postData[innerData.name] = innerData.value
                    } else rangeObj[`range${rangeCount}`][innerData.name] = innerData.value
                }
            })
            if (postData['rules']['range_based'] && Object.keys(postData['rules']['range_based'][metricFuncVal]).length == 0) {
                postData['rules'] = []
            }
            CallAPI('POST', '/app/conditionalFormatting', postData, null, 0, function (response) {
                alert(response.information)
                jQuery(`#${target.split('_')[0]}Modal`).modal('toggle')
                that.handleSyncClick()
            }, this.props.authData);
        }
    }

    getSelectedMetric = (opt) => {
        return opt.$trigger[0].id.split(';')[0] + ';' + opt.$trigger[0].id.split(';')[1].split('_')[0]
    }
    filterValuesToShow = (data, prevProps) => {
        this.tagsDefining();
        var metric_multi = this.state.metric_multi;
        // if((prevProps && data.period == 'Aggregate' && prevProps.period != data.period) || (data.propertyDisp && data.propertyDisp.type == 'propertyLabel'))
        //     metric_multi = false;
        this.setState({
            ...data,
            insightPoint: data.insightPoint,
            period: data.period,
            insightEnable: false,
            metric_multi: metric_multi,
            pageName: data.pageName
        })
        //if property multi then show tags
        // if (data.propMulti) {
        jQuery('#propertySelect>.bootstrap-tagsinput').show();//if tag feild is hidden so always enable when property is multi
        var elt = jQuery('#property-taginput');
        elt.tagsinput('removeAll');//remove all tags default
        if (data.propertyDisp) {//if properties exist then need to print
            if ((typeof data.propertyDisp == 'object')) {//if property array is object type
                if (data.propertyDisp.length) {//if property is object and has multiple array then iterate
                    data.propertyDisp.map(function (innerData) {
                        elt.tagsinput('add', innerData);
                    })
                }
                else elt.tagsinput('add', data.propertyDisp);
            } else {
                data.propertyDisp.map(function (innerData) {
                    elt.tagsinput('add', innerData);
                })
            }
        }
        // } else {
        //     //if property != multi then hide tags
        //     jQuery('#propertySelect>.bootstrap-tagsinput').hide();
        // }
        //filter tags
        var eltFilter = jQuery('#filter-taginput');
        eltFilter.tagsinput('removeAll');//remove all tags default
        if (data.SelectedBreakUpDisp) {//if properties exist then need to print
            if ((typeof data.SelectedBreakUpDisp == 'object')) {//if property array is object type
                if (data.SelectedBreakUpDisp.length) {//if property is object and has multiple array then iterate
                    data.SelectedBreakUpDisp.map(function (innerData) {
                        eltFilter.tagsinput('add', innerData);
                    })
                }
                else eltFilter.tagsinput('add', data.SelectedBreakUpDisp);
            } else {
                data.SelectedBreakUpDisp.map(function (innerData) {
                    eltFilter.tagsinput('add', innerData);
                })
            }
        }
        //Include tags
        var eltInclude = jQuery('#include-taginput');
        eltInclude.tagsinput('removeAll');//remove all tags default
        if (data.includeDisp) {//if properties exist then need to print
            if ((typeof data.includeDisp == 'object')) {//if property array is object type
                if (data.includeDisp.length) {//if property is object and has multiple array then iterate
                    data.includeDisp.map(function (innerData) {
                        eltInclude.tagsinput('add', innerData);
                    })
                }
                else eltInclude.tagsinput('add', data.includeDisp);
            } else {
                data.includeDisp.map(function (innerData) {
                    eltInclude.tagsinput('add', innerData);
                })
            }
        }
        //Exclude tags
        var eltExclude = jQuery('#exclude-taginput');
        eltExclude.tagsinput('removeAll');//remove all tags default
        if (data.excludeDisp) {//if properties exist then need to print
            if ((typeof data.excludeDisp == 'object')) {//if property array is object type
                if (data.excludeDisp.length) {//if property is object and has multiple array then iterate
                    data.excludeDisp.map(function (innerData) {
                        eltExclude.tagsinput('add', innerData);
                    })
                }
                else eltExclude.tagsinput('add', data.excludeDisp);
            } else {
                data.excludeDisp.map(function (innerData) {
                    eltExclude.tagsinput('add', innerData);
                })
            }
        }
        //metric tags
        var eltMetric = jQuery('#metric-taginput');
        eltMetric.tagsinput({
            itemValue: 'value',
            itemText: 'label',
            tagClass: function (item) {
                return (item.isDerived !== '2' ? 'label label-info contextAllow' : 'label label-info noContext');
            }
        });
        eltMetric.tagsinput('removeAll');//remove all tags default
        if (data.selectedMetricDisp) {//if properties exist then need to print
            if ((typeof data.selectedMetricDisp == 'object')) {//if property array is object type
                if (data.selectedMetricDisp.length) {//if property is object and has multiple array then iterate
                    data.selectedMetricDisp.map(function (innerData) {
                        if (typeof innerData == "object")
                            eltMetric.tagsinput('add', innerData);
                    })
                }
                else eltMetric.tagsinput('add', data.selectedMetricDisp);
            } else {
                data.selectedMetricDisp.map(function (innerData) {
                    eltMetric.tagsinput('add', innerData);
                })
            }
        }

        var that = this;
        var $temp_metricFunction = {};
        let $temp_metricFunctionOrdered = {};
        if (metricFunction) {
            metricFunction = typeof (metricFunction) == "object" ? Object.values(metricFunction) : metricFunction
            metricFunction.map(function (innerData) {
                if (innerData.value) {

                    if ($temp_metricFunction[innerData.metricGroup]){
                         innerData.type='checkbox'
                         $temp_metricFunction[innerData.metricGroup]['items'][innerData.value] = innerData ;
                    }
                    else {
                        let group =innerData.metricGroup;
                        if (group != 'Runrate' && group != 'Compare' && group != 'Default') {
                            $temp_metricFunction[innerData.metricGroup] = { "name": innerData.metricGroup, "items": {} };
                            innerData.type = 'checkbox'
                            $temp_metricFunction[innerData.metricGroup]['items'][innerData.value] = innerData;
                        }
                    }
                    // $temp_metricFunction[innerData.value] = innerData
                }
            })
            // $temp_metricFunction['Conditional Formatting'] = {
            //     'name': 'Conditional Formatting', 'items': {
            //         'rangeBased': {
            //             name: 'Range Based',
            //             value: 'rangeBased',
            //             callback: function (key, opt) {
            //                 key = opt.commands[key].value
            //                 selectedMetricValue = that.getSelectedMetric(opt)
            //                 that.handleFormattingModal(key);
            //             }
            //         },
            //         'comparison': {
            //             name: 'Compare Based',
            //             value: 'comparison',
            //             callback: function (key, opt) {
            //                 key = opt.commands[key].value
            //                 selectedMetricValue = that.getSelectedMetric(opt)
            //                 that.handleFormattingModal(key);
            //             }
            //         },
            //         // 'compareMultiple': {
            //         //     name: 'Comparison with multiple benchmarks',
            //         //     value: 'compareMultiple',
            //         //     callback: function (key, opt) {
            //         //         key = opt.commands[key].value
            //         //         selectedMetricValue = that.getSelectedMetric(opt)
            //         //         that.handleFormattingModal(key);
            //         //     }
            //         // }
            //     }
            // }
         
            // Prioritize keys, and skiping missing groups
            let priorityKeys = [
                "Compare with Last Year",
                "Compare with Last Month",
                "Compare with Last Quarter",
                "Compare with Last Week",
                "Compare with Last Day",
                "Contribution",
                "CAGR"
            ];
            priorityKeys.forEach(function (key) {
                if ($temp_metricFunction[key]) {
                    $temp_metricFunctionOrdered[key] = $temp_metricFunction[key];
                }
            });
            Object.keys($temp_metricFunction).forEach(function (key) {
                if (!priorityKeys.includes(key)) {
                    $temp_metricFunctionOrdered[key] = $temp_metricFunction[key];
                }
            });
            Object.keys($temp_metricFunctionOrdered).forEach(function (key) {
                $temp_metricFunctionOrdered[key]['items'] = {
                    ...$temp_metricFunctionOrdered[key]['items'],
                    "sep1": "---------",
                    submit: {
                        name: "Submit Selection",
                        callback: function (key, options) {
                            
                            // $('ul[selecttype="metric"]').append('<div class="spinner-border spinner-border-sm" role="status">...</div>')
                            // Ensure the key is retrieved properly from the context menu items
                            key = options.commands[key].value;

                            // Collect selected checkbox values
                            let selectedOptions = [];
                            $('.context-menu-item input:checked').each(function () {
                                selectedOptions.push($(this).val());
                            });
                            // Retrieve values from inputs (checkboxes, radio buttons, etc.)
                            let checkboxSelectedValues = [];
                            let data = {};
                            $.contextMenu.getInputValues(options, data);
                        
                            // Filter and collect selected checkbox values
                            for (let [inputKey, value] of Object.entries(data)) {
                                if (value === true) {
                                    checkboxSelectedValues.push(inputKey);
                                }
                            }
                            // Process selected values
                            let id = options.$trigger[0].id;
                            let parentValue = selectedMetricDisp.filter((v) => v.value.split(";")[0] == id.split(";")[0]);
                            let metaKPisArray = []
                            let removedValues = []
                            checkboxSelectedValues.map((val) => {
                                if (!selectedMetricDisp.some((metric) => {return metric.value === id.split(";")[0]+";"+val})) {
                                    metaKPisArray.push(val);
                                }else{
                                    removedValues.push(val.toUpperCase() + " ");
                                }
                            })
                            if (removedValues.length > 0) {
                                alert(`${[...removedValues]} ${removedValues.length == 1 ? "is" : "are"} already selected.`)
                            }
                            if (parentValue) {
                                let processHeavyOperation = (label, value) => {
                                    return new Promise((resolve) => {
                                        setTimeout(() => { // Simulate async work with setTimeout
                                            that.replaceWordWithFunction(label, value, selectedMetricDisp, $handleChange);
                                            resolve();
                                        }, 0); // Replace 0 with the actual async operation or Promise
                                    });
                                };
                        
                                // Execute the heavy operations asynchronously
                                (async () => {
                                    for (let value of metaKPisArray) {
                                        let spinnerEle = document.createElement("div"); //appending loader 
                                        spinnerEle.classList.add("spinner-border", "spinner-border-sm", "m-auto");
                                        spinnerEle.setAttribute("role", "status");

                                        let metricList = document.querySelector('ul[selecttype="metric"]');
                                        if (metricList) {
                                            metricList.appendChild(spinnerEle);
                                        }
                                        await processHeavyOperation(parentValue[0].label, value);

                                    }
                        
                                    // Hide context menu
                                    $('.context-menu-list').trigger('contextmenu:hide');
                                })();
                            }
                        }, icon: function () {
                            return 'context-menu-icon context-menu-icon-edit btn  mg-l-3 wd-95p';
                        }
                    }
                }
            })
        }

        filterArray.map(function (innerData) {
            let elementId = null, contextMenuItems = [];
            switch (innerData) {
                case "metric":
                    elementId = data.selectedMetric;
                    contextMenuItems = $temp_metricFunctionOrdered;
                    break;
                case "property":
                    elementId = data.property;
                    break;
                case "include":
                    elementId = data.include;
                    break;
                case "exclude":
                    elementId = data.exclude;
                    break;
                case "breakup":
                    elementId = data.breakup && typeof data.breakup != "function" ? data.breakup : innerData;
                    break;
            }
            elementId = elementId ? (((elementId.replace(/ /g, "")).replace(/,/g, "_")).replace(/;/g, "_")).replace(/[^\w\s]/gi, "") : innerData;
            setTimeout(() => {
                jQuery(`#ulFilterDrag_${elementId}`).sortable({
                    stop: function (event, ui) {
                        let metricData = that.state.selectedMetric ? that.state.selectedMetric.split(',') : that.props.selectedMetric.split(','),
                            propertyData = that.state.property ? that.state.property.split(',') : that.props.property.split(',')
                        let propertyDisp = that.state.propertyDisp ? that.state.propertyDisp : that.props.propertyDisp,
                            metricDisp = that.state.selectedMetricDisp ? that.state.selectedMetricDisp : (that.props.selectedMetricDisp ? that.props.selectedMetricDisp : []);
                        var nextProps = { ...that.state };
                        switch (this.getAttribute("selecttype")) {
                            case "metric":
                                let newMetricData = $(`#${event.target.id}`).sortable("toArray")
                                metricData.map(function (innerData) {
                                    if (newMetricData.indexOf(innerData) == -1) {
                                        newMetricData[newMetricData.indexOf("")] = innerData
                                    }
                                })
                                metricData = newMetricData;
                                metricDisp = metricDataToDisp(that.state.Metric, that.state.metricFunction, metricData.toString())
                                nextProps = { ...nextProps, 'selectedMetric': metricData.toString(), 'selectedMetricDisp': metricDisp }
                                break;
                            case "property":
                                let newPropertyData = $(`#${event.target.id}`).sortable("toArray")
                                propertyData.map(function (innerData) {
                                    if (newPropertyData.indexOf(innerData) == -1) {
                                        newPropertyData[newPropertyData.indexOf("")] = innerData
                                    }
                                })
                                propertyData = newPropertyData;
                                propertyDisp = getPropertyDisp(propertyData.toString(), that.state.datasetDetails.alfred.property)
                                nextProps = { ...nextProps, 'property': propertyData.toString(), 'propertyDisp': propertyDisp }
                                break;
                        }
                        filterData = { "selectedMetric": metricData.toString(), "selectedMetricDisp": metricDisp, "property": propertyData.toString(), "propertyDisp": propertyDisp, "breakup": that.props.breakup, "timeGran": that.state.period, "clicked": this.getAttribute("selecttype") }
                        that.setState({ ...that.state, filterData })
                        that.customComponentWillReceiveProps(nextProps, that.props);
                    }
                });
                jQuery.contextMenu({
                    selector: `.${innerData}_moreOptions`,
                    trigger: 'left',
                    // callback: function (key, options) {
                    // key = options.commands[key].value;
                    // (this[0].parentElement.innerText, key, selectedMetricDisp, $handleChange);
                    // },
                    items: contextMenuItems,
                    events: {
                        show: function (opt) {
                            var $this = this;
                            // Import data to inputs
                            $.contextMenu.setInputValues(opt, $this.data());
                        }, 
                    }
                    
                });
            }, 500)
        })
    }
    findToggleIndex = (objectArray, toReplaceValue) => {
        let value = toReplaceValue.split(";")[0];
        let indexToggle;
        let arr = objectArray.map(function (item, index) {
            if (item.isDisplay == 1 && item.value === value) {
                indexToggle = index;
                return item;
            }
        })
        return indexToggle;
    }
    handleObjectArrayForMap = (geoDimensionArray,optionsObj)=>{
        let keys = geoDimensionArray.split(",");
        let options = Object.values(optionsObj).filter((val)=>keys.includes(val.value))
        return options;
    }
    toggleIndex = (type, toReplaceValue, toggleType) => {
        if (toggleType == "change") {
            this.setState({
                filterTagsToHandle: toReplaceValue
            })
        } else {
            var elementId = null, elementSelected = null, elementData = null, objectArray = [], toggleIndex = 0, elementSelectedArray = [], fullElementData = null;
            switch (type) {
                case "metric":
                    elementId = this.state.selectedMetric ? this.state.selectedMetric : this.props.selectedMetric;
                    objectArray = []
                    this.props.Metric.map(function (innerData) {
                        if (innerData.isDisplay == 1) {
                            objectArray.push(innerData)
                        }
                    });
                    // toggleIndex = metricToggleIndex;
                    toggleIndex = this.findToggleIndex(objectArray, toReplaceValue);
                    fullElementData = [...this.state.selectedMetricDisp]
                    break;
                case "property":
                    elementId = this.state.property ? this.state.property : this.props.property;
                    objectArray = this.state.chartCat === "Map" ? this.props.geoLocationDimesnionArray ? this.handleObjectArrayForMap(this.props.geoLocationDimesnionArray,this.props.datasetDetails.alfred.property) : Object.values(this.props.datasetDetails.alfred.property,): Object.values(this.props.datasetDetails.alfred.property);
                    toggleIndex = Object.keys(this.props.datasetDetails.alfred.property).indexOf(toReplaceValue.toLowerCase());
                    fullElementData = [...this.state.propertyDisp]
                    break;
                case "include":
                    elementId = this.state.include ? this.state.include : this.props.include;
                    objectArray = Object.values(this.props.datasetDetails.alfred.property);
                    toggleIndex = propertyToggleIndex;
                    fullElementData = [...this.state.includeDisp]
                    break;
                case "exclude":
                    elementId = this.state.exclude ? this.state.exclude : this.props.exclude;
                    objectArray = Object.values(this.props.datasetDetails.alfred.property);
                    toggleIndex = propertyToggleIndex;
                    fullElementData = [...this.state.excludeDisp]
                    break;
                case "breakup":
                    elementId = this.state.breakup ? this.state.breakup : this.props.breakup;
                    objectArray = Object.values(this.props.datasetDetails.alfred.property);
                    toggleIndex = propertyToggleIndex;
                    fullElementData = [...this.state.SelectedBreakUpDisp]
                    break;
            }
            elementId = elementId ? (((elementId.replace(/ /g, "")).replace(/,/g, "_")).replace(/;/g, "_")).replace(/[^\w\s]/gi, "") : type;
            elementData = $(`#ulFilterDrag_${elementId}`).sortable("toArray");
            let foundIndex = elementData.indexOf(toReplaceValue);

            if (toggleType != "remove") {
                toggleIndex = toggleType == "down" ?
                    (objectArray.length - 1 <= toggleIndex ? 0 : toggleIndex + 1) :
                    (toggleIndex == 0 ? objectArray.length - 1 : toggleIndex - 1);

                elementSelected = objectArray[toggleIndex] ? objectArray[toggleIndex] : objectArray[0];

                while (elementData.indexOf(`${elementSelected.value};${elementSelected.defaultFormula}`) != -1 || elementData.indexOf(`${elementSelected.value}`) != -1) {
                    toggleIndex = toggleType == "down" ?
                        (objectArray.length - 1 <= toggleIndex ? 0 : toggleIndex + 1) :
                        (toggleIndex <= 0 ? objectArray.length - 1 : toggleIndex - 1);

                    elementSelected = objectArray[toggleIndex];
                }
                fullElementData[foundIndex] = elementSelected
            }
            if (toggleType == "remove") {
                elementData.splice(foundIndex, 1)
                fullElementData.splice(foundIndex, 1)
            } else elementData[foundIndex] = type == "metric" ? `${elementSelected.value};${elementSelected.defaultFormula}` : `${elementSelected.value}`;

            let selectedMetric = this.state.selectedMetric ? this.state.selectedMetric : this.props.selectedMetric,
                property = this.state.property ? this.state.property : this.props.property,
                breakup = this.state.breakup ? this.state.breakup : this.props.breakup,
                exclude = this.state.exclude ? this.state.exclude : this.props.exclude,
                include = this.state.include ? this.state.include : this.props.include
            let newMetricRange = "";
            switch (type) {
                case "metric":
                    selectedMetric = elementData && elementData.length > 0 ? elementData.toString() : 'empty';
                    metricToggleIndex = toggleIndex
                    let baseUrlMetric = getParameters("metricRange");
                    if (baseUrlMetric) {
                        let arr = baseUrlMetric.split(",");
                        arr.map((ele) => {
                            if (!ele.includes(toReplaceValue)) {
                                newMetricRange += `${ele},`
                                return ele;
                            }
                        });
                        newMetricRange = newMetricRange.substring(0, newMetricRange.length - 1);
                        if (newMetricRange === "") {
                            newMetricRange = "empty"
                        }
                        let currentUrl = window.location.search + `&metricRange=${newMetricRange}`
                        let urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
                        updateURL(urlObj, '', true)
                        //setMetricRange({metricRange:newMetricRange});
                    }
                    break;
                case "property":
                    property = elementData && elementData.length > 0 ? elementData.toString() : 'empty';
                    propertyToggleIndex = toggleIndex
                    break;
                case "breakup":
                    breakup = elementData && elementData.length > 0 ? elementData.toString() : 'empty';
                    break;
                case "exclude":
                    exclude = elementData && elementData.length > 0 ? elementData.toString() : 'empty';
                    break;
                case "include":
                    include = elementData && elementData.length > 0 ? elementData.toString() : 'empty';
                    break;
            }

            if (type === "property" && property === "empty") {
                fullElementData = { label: 'Total', value: 'all', type: "propertyLabel" }
            }
            if (Array.isArray(fullElementData)) {
                elementSelectedArray = [...fullElementData]
            } else {
                elementSelectedArray.push(fullElementData)
            }
            var nextProps = { ...this.state };
            if (filterData.clicked !== "") {
                if ((filterData.clicked).includes(type) === false) {
                    filterData.clicked = `${filterData.clicked},${type}`
                }
            } else filterData = { ...filterData, "selectedMetric": selectedMetric, "property": property, "breakup": breakup, "timeGran": this.state.period, clicked: type, "include": include, "exclude": exclude }

            switch (type) {
                case "metric":
                    filterData.selectedMetric = selectedMetric
                    filterData.selectedMetricDisp = elementSelectedArray
                    nextProps = { ...nextProps, 'selectedMetric': selectedMetric, 'selectedMetricDisp': [...elementSelectedArray] }
                    break;
                case "property":
                    filterData.property = property
                    filterData.propertyDisp = elementSelectedArray
                    nextProps = { ...nextProps, 'property': property, 'propertyDisp': [...elementSelectedArray] }
                    break;
                case "breakup":
                    filterData.breakup = breakup
                    filterData.SelectedBreakUpDisp = elementSelectedArray
                    nextProps = { ...nextProps, 'breakup': breakup, 'SelectedBreakUpDisp': [...elementSelectedArray] }
                    break;
                case "exclude":
                    filterData.exclude = exclude
                    filterData.excludeDisp = elementSelectedArray
                    nextProps = { ...nextProps, 'exclude': exclude, 'excludeDisp': [...elementSelectedArray] }
                    break;
                case "include":
                    filterData.include = include
                    filterData.includeDisp = elementSelectedArray
                    nextProps = { ...nextProps, 'include': include, 'includeDisp': [...elementSelectedArray] }
                    break;
            }
            this.setState({ ...this.state, filterData })
            this.customComponentWillReceiveProps(nextProps, this.props);
        }
    }
    selectLoad = (input, callback) => {
        var that = this;
        let selectedFilterBy = that.state.breakup ? that.state.breakup : that.props.breakup;
        if (selectedFilterBy === undefined) {
            selectedFilterBy = "";
        }
        asyncFilter(input, null, callback, this.props.authData, null, selectedFilterBy);
    }
    selectIncludeLoad = (input, callback) => {
        var that = this;
        let selectedInclude = that.state.include ? that.state.include : that.props.include;
        asyncFilter(input, 'include_filter', callback, this.props.authData, null, selectedInclude);
    }
    selectExcludeLoad = (input, callback) => {
        var that = this;
        let selectedExclude = that.state.exclude ? that.state.exclude : that.props.exclude;
        asyncFilter(input, 'exclude_filter', callback, this.props.authData, null, selectedExclude);
    }
    changeChart(e, type) {
        var nextProps = { ...this.state }
        if (e == 'time') {
            type = type.value;
            // Set transpose to false
            var tempStartDate = moment(this.state.startDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            var tempEndDate = moment(this.state.endDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            var dateDiff = moment(tempStartDate, 'YYYY-MM-DD').diff(moment(tempEndDate, 'YYYY-MM-DD'), 'days');
            if (type == "Day" && dateDiff < -365) {
                jQuery('.dateText').text(moment(this.state.startDate).format(dateFormatCalendar1) + ' - ' + moment(this.state.endDate).format(dateFormatCalendar2));
                alert("Day wise data can be viewed for one year only.");
                return null;
            }
            var transpose = type ? 'false' : this.state.transpose;
            metricGlobal = modifyMetricGlobal(metricGlobal, 'report', type);
            if (filterData.clicked !== "") {
                filterData.timeGran = type
                if ((filterData.clicked).includes('period') === false)
                    filterData.clicked = `${filterData.clicked},period`;
            } else filterData = { ...filterData, "timeGran": type, clicked: 'period' }
            nextProps = { ...nextProps, 'period': type }
            this.setState({ ...this.state, filterData });
            this.customComponentWillReceiveProps(nextProps, this.props);
        } else if (e == 'outputType') {
            if (type.value == "transpose") {
                var transposeValue = type.value == "transpose" ? true : false
                var currentUrl = window.location.search + `&transpose=${transposeValue}`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
                updateURL(urlObj, '', false)
                if (filterData.clicked !== "") {
                    filterData['transpose'] = transposeValue;
                    filterData['crosstab_flag'] = true;
                    filterData['kpiMonitoring'] = false;
                    if ((filterData.clicked).includes('outputType') === false)
                        filterData.clicked = `${filterData.clicked},outputType`;
                } else filterData = { ...filterData, "transpose": transposeValue, "crosstab_flag": true, 'kpiMonitoring': false, clicked: 'outputType' }
                nextProps = { ...nextProps, transpose: transposeValue, "crosstab_flag": true, 'kpiMonitoring': false }
                this.setState({ ...this.state, filterData });
                this.customComponentWillReceiveProps(nextProps, this.props);
            } else if (type.value == "crosstab") {
                var currentUrlParams = window.location.search + `&multiDim=false`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrlParams));
                updateURL(urlObj, '', true)
                if (filterData.clicked !== "") {
                    filterData['crosstab_flag'] = false;
                    filterData['transpose'] = false;
                    filterData['kpiMonitoring'] = false;
                    if ((filterData.clicked).includes('outputType') === false)
                        filterData.clicked = `${filterData.clicked},outputType`;
                } else filterData = { ...filterData, "crosstab_flag": false, "transpose": false, 'kpiMonitoring': false, clicked: 'outputType' }
                nextProps = { ...nextProps, crosstab_flag: false, "transpose": false, 'kpiMonitoring': false }
                this.setState({ ...this.state, filterData });
                this.customComponentWillReceiveProps(nextProps, this.props);
            } else if (type.value == "kpiMonitoring") {
                var kpiMonitoringValue = type.value == "kpiMonitoring" ? true : false
                var currentUrl = window.location.search + `&kpiMonitoring=${kpiMonitoringValue}`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
                updateURL(urlObj, '', false)
                let allPropertyDisp = [{ label: 'Total', value: 'all', type: "propertyLabel" }]
                if (filterData.clicked !== "") {
                    filterData['kpiMonitoring'] = kpiMonitoringValue;
                    filterData['transpose'] = false;
                    filterData['crosstab_flag'] = true;
                    filterData['property'] = "empty"
                    filterData['propertyDisp'] = allPropertyDisp
                    if ((filterData.clicked).includes('outputType') === false)
                        filterData.clicked = `${filterData.clicked},outputType`;
                } else filterData = { ...filterData, "kpiMonitoring": kpiMonitoringValue, "transpose": false, "crosstab_flag": true, clicked: 'outputType', property: 'empty', propertyDisp: allPropertyDisp }
                nextProps = { ...nextProps, kpiMonitoring: kpiMonitoringValue, "transpose": false, "crosstab_flag": true, property: 'empty', propertyDisp: allPropertyDisp }
                this.setState({ ...this.state, filterData });
                this.customComponentWillReceiveProps(nextProps, this.props);
            } else {
                var currentUrlParams = window.location.search + `&multiDim=true&transpose=false&kpiMonitoring=false`
                var urlObj = Object.fromEntries(new URLSearchParams(currentUrlParams));
                updateURL(urlObj, '', true)
                if (filterData.clicked !== "") {
                    filterData['transpose'] = false;
                    filterData['crosstab_flag'] = true;
                    filterData['kpiMonitoring'] = false;
                    if ((filterData.clicked).includes('outputType') === false)
                        filterData.clicked = `${filterData.clicked},outputType`;
                } else filterData = { ...filterData, "transpose": false, "crosstab_flag": true, 'kpiMonitoring': false, clicked: 'outputType' }
                nextProps = { ...nextProps, transpose: false, crosstab_flag: true, kpiMonitoring: false }
                this.setState({ ...this.state, filterData });
                this.customComponentWillReceiveProps(nextProps, this.props);
            }
        }
    }
    handleSortOrder = (e, type) => {
        let nextProps = { ...this.state }
        let sortOrderValue = type ? type.value : this.state.sortOrder;
        if (filterData.clicked !== "") {
            filterData.sortOrder = sortOrderValue
            if ((filterData.clicked).includes('sortOrder') === false)
                filterData.clicked = `${filterData.clicked},sortOrder`;
        } else filterData = { ...filterData, "sortOrder": sortOrderValue, clicked: 'sortOrder' }
        nextProps = { ...nextProps, 'sortOrder': sortOrderValue }
        this.setState({ ...this.state, filterData });
        this.customComponentWillReceiveProps(nextProps, this.props);
    }
    handleLimit = (e, type) => {
        let nextProps = { ...this.state }
        let limitValue = type ? type.value : this.state.limit;
        if (filterData.clicked !== "") {
            filterData.limit = limitValue
            if ((filterData.clicked).includes('limit') === false)
                filterData.clicked = `${filterData.clicked},limit`;
        } else filterData = { ...filterData, "limit": limitValue, clicked: 'limit' }
        nextProps = { ...nextProps, 'limit': limitValue }
        this.setState({ ...this.state, filterData });
        this.customComponentWillReceiveProps(nextProps, this.props);
    }
    selectPropLoad = (input, callback) => {
        var that = this;
        let chartCat = getParametersFromString('chartCat', location.search)
        chartCat = chartCat && chartCat == 'Map' ? "locationColumns" : (that.state.pageName == "dashboard" ? "propertyLabel" : "propLabel");
        let selectedDimensions = that.state.property ? that.state.property : that.props.property; 
        let geoDimensionArray = chartCat=="locationColumns" ? that.props.geoLocationDimesnionArray : null //locationArray - Handling dimensions for map chart.
        asyncFilter(input, chartCat, callback, that.props.authData, null, selectedDimensions, geoDimensionArray);
    }
    closeClusterInsight = () => {
        var width = jQuery('#SidebarInsightDiv').width();
        if (width)
            closeSidebar('SidebarInsightDiv');
        closeSidebar('FilterDiv');
        defaultFilterFlag = '0'
        this.props.removeFilter();
        jQuery("#main-content").css("marginRight", "0px");
        var url = document.location.pathname;
        if (url == '/dashboard/charttype' && highChartsDiv) {
            highChartsDiv.reflow();
        }
        if (url == '/dashboard/dashboard' && highChartsDiv) {
            dragcomplete();
        }
    }
    toggleLabels = () => {
        var sampleChart = highChartsDiv;
        var dataLabel = jQuery('#dataLabels').html();
        if (dataLabel == "Add Data Labels") {
            this.setState({
                dataLabelsButton: "Remove Data Labels"
            });
            // jQuery('#dataLabels').html("Remove Data Labels");
        }
        else {
            this.setState({
                dataLabelsButton: "Add Data Labels"
            });
            // jQuery('#dataLabels').html("Add Data Labels");
        }
        // var optMain = sampleChart.series;
        // if(optMain.length>1){
        //     for (var i = 0; i < optMain.length; i++) {
        //         optMain[i].options.dataLabels.enabled = !optMain[i].options.dataLabels.enabled;
        //     }
        //     sampleChart.update(optMain);
        // }else {
        for (var i = 0; i < sampleChart.series.length; i++) {
            var opt = sampleChart.series[i].options;
            opt.dataLabels.enabled = !opt.dataLabels.enabled;
            sampleChart.series[i].update(opt);
        }
        // }
    }
    propertyHandle = (e, replaceType, type) => {
        //commented below code as it was closing filter panel on change of dimension in mobile
        // if (jQuery(window).width() <= mobile_width) {
        //     this.closeClusterInsight();
        // }
        var check = false;
        var item;
        var checkTotal = false;

        if (type[0]) {
            item = type[0];
        } else {
            item = type;
        }
        var arrayData = this.state.propertyDisp ? this.state.propertyDisp : this.props.propertyDisp;
        let arrayDataLen = arrayData.length;
        check = checkInArray(arrayData, item);
        if (replaceType == 1 && item.value == "" && arrayDataLen == 1) {
            checkTotal = true;
        }

        if (item.value != "" || checkTotal == true) {
            if (!check || checkTotal == true) {
                if (replaceType != 1) {
                    if (typeof type == "object") {
                        if (!propMulti) {
                            arrayData = [];
                        }
                        if (type.length)
                            arrayData.push(type[0]);
                        else {
                            // This is to handle the case when dimension is changed from up, down toggle 
                            arrayData = []
                            arrayData.push(type);
                        }
                    } else arrayData.push(type);

                    var crosstabObj = {};
                    if (this.props.pageName == "report" && arrayData.length == 2) {
                        crosstabObj = {
                            crosstab_flag: "true",
                            transpose: "false",
                            kpiMonitoring: 'false'
                        }
                    } else {
                        crosstabObj = {
                            crosstab_flag: "true",
                            transpose: "false",
                            kpiMonitoring: 'false'
                        }
                    }
                } else {
                    let filterTagsToHandle = this.state.filterTagsToHandle;
                    let finalData = arrayData.map(function (innerData) {
                        if (innerData.value == filterTagsToHandle) {
                            return type
                        } return innerData
                    })
                    arrayData = finalData;
                }
            } else {
                alert("Already Selected");
            }
        } else {
            alert("Cannot Add this");
        }
        var nextProps = { ...this.state };
        let propertyVal = arrayData.map(a => a.value).toString();
        if (filterData.clicked !== "") {
            filterData.property = propertyVal === "all" ? "empty" : propertyVal
            filterData.propertyDisp = arrayData
            if ((filterData.clicked).includes('property') === false)
                filterData.clicked = `${filterData.clicked},property`;
        } else {
            filterData = { "selectedMetric": this.props.selectedMetric, "property": propertyVal === "all" ? "empty" : propertyVal, "propertyDisp": arrayData, "breakup": this.props.breakup, "timeGran": this.state.period, "clicked": "property" }
        }
        nextProps = { ...nextProps, 'property': propertyVal === "all" ? "empty" : propertyVal, 'propertyDisp': arrayData }
        this.setState({ ...this.state, filterData });
        this.customComponentWillReceiveProps(nextProps, this.props);
    }
    filterHandle = (e, type) => {
        let temp_variable = null;
        let refresh_variable = null;
        var breakup = this.state.breakup, include = this.state.include, exclude = this.state.exclude, input = '';
        switch (e) {
            case 'breakup':
                temp_variable = this.props.SelectedBreakUpDisp;
                refresh_variable = this.refs.breakupFilter;
                breakup = this.state.SelectedBreakUpDisp ? this.arrayData(this.state.SelectedBreakUpDisp, type) : this.arrayData(this.props.SelectedBreakUpDisp, type);
                break;
            case 'include':
                temp_variable = this.props.includeDisp;
                refresh_variable = this.refs.breakupInclude;
                include = this.state.includeDisp ? this.arrayData(this.state.includeDisp, type) : this.arrayData(this.props.includeDisp, type);
                break;
            case 'exclude':
                temp_variable = this.props.excludeDisp;
                refresh_variable = this.refs.breakupExclude;
                exclude = this.state.excludeDisp ? this.arrayData(this.state.excludeDisp, type) : this.arrayData(this.props.excludeDisp, type);
                break;
        }
        var nextProps = { ...this.state }
        if (filterData.clicked !== "") {
            if ((filterData.clicked).includes(e) === false)
                filterData.clicked = `${filterData.clicked},${e}`;
        } else filterData = { ...filterData, "selectedMetric": this.props.selectedMetric, "property": this.props.property, "breakup": breakup, "timeGran": this.state.period, "clicked": e, "include": include, "exclude": exclude }
        switch (e) {
            case 'breakup':
                filterData.breakup = breakup
                filterData.SelectedBreakUpDisp = this.state.SelectedBreakUpDisp
                nextProps = { ...nextProps, 'breakup': breakup, 'SelectedBreakUpDisp': this.state.SelectedBreakUpDisp }
                break
            case 'include':
                filterData.include = include
                filterData.includeDisp = this.state.includeDisp
                nextProps = { ...nextProps, 'include': include, 'includeDisp': this.state.includeDisp }
                break
            case 'exclude':
                filterData.exclude = exclude
                filterData.excludeDisp = this.state.excludeDisp
                nextProps = { ...nextProps, 'exclude': exclude, 'excludeDisp': this.state.excludeDisp }
                break
        }
        this.setState({ ...this.state, filterData })
        this.customComponentWillReceiveProps(nextProps, this.props);
    }
    arrayData(arrayData, type) {
        arrayData = arrayData ? arrayData : [];
        var check = checkInArray(arrayData, type[0]);
        if (!check) {
            if (typeof type == "object") {
                if (type.length)
                    arrayData.push(type[0]);
                else arrayData.push(type);
            } else {
                arrayData.push(type);
            }
        }
        return arrayData.map(a => a.value).toString();
    }
    metricHandle = (e, replaceType, type) => {
        var arrayData = [], input = '', check = false;
        // asyncFilter(input, 'propLabel', callback);
        if (type[0])
            type = type[0];
        type = addDefaultFunction(type, Object.values($metricFunction), type.defaultFormula);
        arrayData = this.state.selectedMetricDisp ? this.state.selectedMetricDisp : (this.props.selectedMetricDisp ? this.props.selectedMetricDisp : []);
        check = checkInArray(arrayData, type);
        if (!check) {
            if (replaceType != 1) {
                if (typeof type == "object") {
                    if (metricMulti) {
                        arrayData.push(type);
                    } else {
                        arrayData = [];
                        arrayData.push(type);
                    }
                }
                selectedMetricDisp = arrayData;
            } else {
                let filterTagsToHandle = this.state.filterTagsToHandle;
                let finalData = arrayData.map(function (innerData) {
                    if (innerData.value == filterTagsToHandle) {
                        return type
                    } return innerData
                })
                selectedMetricDisp = arrayData = finalData;
            }
            var nextProps = { ...this.state }
            if (filterData.clicked !== "") {
                filterData.selectedMetric = arrayData.map(a => a.value).toString()
                filterData.selectedMetricDisp = arrayData
                if ((filterData.clicked).includes('metric') === false)
                    filterData.clicked = `${filterData.clicked},metric`;
            } else filterData = { ...filterData, "selectedMetric": arrayData.map(a => a.value).toString(), "selectedMetricDisp": arrayData, "property": this.props.property, "breakup": this.props.breakup, "timeGran": this.state.period, "clicked": 'metric' }
            nextProps = { ...nextProps, 'selectedMetric': arrayData.map(a => a.value).toString(), 'selectedMetricDisp': arrayData }
            this.setState({ ...this.state, filterData });
            this.customComponentWillReceiveProps(nextProps, this.props);
        } else {
            alert("Already Selected!");
        }
    }
    closeSidebarAndOpenFilter = (action) => {
        var width = jQuery('#SidebarInsightDiv').width();
        if (width)
            closeSidebar('SidebarInsightDiv');
        if (action == 'close') {
            closeSidebar('FilterDiv');
            defaultFilterFlag = '0'
            jQuery("#main-content").css("marginRight", "0px");
        } else {
            var width = jQuery('#FilterDiv').width();
            if (width <= 0) {
                if (jQuery(window).width() >= mobile_width) {
                    openSidebar('FilterDiv', filter_desktop_width);
                    jQuery("#main-content").css("marginRight", main_content_div_filter);
                } else openSidebar('FilterDiv', filter_mobile_width);
            }
        }
        var url = document.location.pathname;
        if (url == '/dashboard/dashboard' && highChartsDiv) {
            highChartsDiv.map(function (innerData, index) {
                highChartsDiv[index].reflow();
            })
        }
    }
    openSidebarInsight = () => {
        this.props.enablePageDescription(true);
        this.setState({ insightEnable: true, insightPoint: null, period: null });
        closeSidebar('FilterDiv');
        // if ((document.getElementById('SidebarInsightDiv') && !document.getElementById('SidebarInsightDiv').style.width) || document.getElementById('SidebarInsightDiv').style.width == '0px')
        //     openSidebar('SidebarInsightDiv', "360px");
    }
    handleInsightEnable = (param) => {
        this.setState({ insightEnable: param });
    }
    handleSaveReportClick = () => {
        jQuery('#saveReportPopup').modal('toggle');
    }
    switchButton = () => {
        jQuery('.chartsHide').toggle();
    }
    property_multi_enable = (e) => {

        let buttonClicked = jQuery(e.target).attr('id').split('-')[0];
        let property_multi_flag = this.state.property_multi;
        let crosstab_flag = this.state.crosstab_flag;
        if (buttonClicked == 'crosstab') {   // Handle Crosstab button clicked
            var enable_crosstab_title = this.state.enable_crosstab_title;
            if (crosstab_flag) {
                document.getElementById('crosstab-enabled').style.color = "#49bf67";
                enable_crosstab_title = 'Disable Crosstab';
            } else {
                document.getElementById('crosstab-enabled').style.color = "black";
                enable_crosstab_title = 'Enable Crosstab';
            }
            crosstab_flag = !crosstab_flag;
            // this.props.chartCat == 'report' ? this.props.handleCrosstabEnable(property_multi_flag) : '';
        } else {    // Handle Multi dimension clicked
            var enable_multi_dimension_title = this.state.enable_multi_dimension_title;
            if (!property_multi_flag) {
                document.getElementById('multi-property-enabled').style.color = "#49bf67";
                enable_multi_dimension_title = 'Disable Multiple Dimensions';
            } else {
                document.getElementById('multi-property-enabled').style.color = "black";
                enable_multi_dimension_title = 'Enable Multiple Dimensions';
            }
            // this.props.chartCat == 'report' ? this.props.handleCrosstabEnable(property_multi_flag) : '';
            property_multi_flag = !property_multi_flag;
        }

        let updateParams = {}
        updateParams.property = this.props.property;
        updateParams.metric = this.props.selectedMetric
        updateParams.breakup = this.props.breakup
        updateParams.startDate = this.props.startDate
        updateParams.endDate = this.props.endDate
        updateParams.chartCat = this.props.chartCat
        updateParams.limit = this.props.limit
        updateParams.sortOrder = this.props.sortOrder
        updateParams.period = this.props.period
        updateParams.include = this.props.include
        updateParams.exclude = this.props.exclude
        updateParams.crosstab_flag = crosstab_flag.toString();

        updateURL(updateParams);

        this.props.setTableActions({ propMulti: property_multi_flag, crosstab_flag: crosstab_flag, enable_multi_dimension_title: enable_multi_dimension_title, enable_crosstab_title: enable_crosstab_title })
    }
    metric_multi_enable = () => {
        if (!this.state.metric_multi) {
            document.getElementById('metric-multi-enabled').style.color = "#49bf67";
        } else document.getElementById('metric-multi-enabled').style.color = "black";
        this.setState({
            metric_multi: !this.state.metric_multi
        })
    }
    handle_next_before = (type) => {
        var data_to_set = {};
        if (type == "down") {
            property_current_index = !refineURLData(getParameters('property')) ? 1 : property_current_index + 1;
            property_current_index = property_current_index >= property_filter.length ? 0 : property_current_index;
            property_current_index = parseInt(property_current_index);
        }
        else {
            property_current_index = !refineURLData(getParameters('property')) ? -1 : property_current_index - 1;
            property_current_index = property_current_index < 0 ? (property_filter.length - 1) : property_current_index;
        }
        data_to_set = property_filter[property_current_index];
        propertyMain = data_to_set.value;
        this.propertyHandle('property', 0, data_to_set, null)
    }
    key_handle_function = (e) => {
        var arrow = { left: 37, up: 38, right: 39, down: 40 };
        switch (e.keyCode) {
            case arrow.left:
                break;
            case arrow.up:
                this.handle_next_before("up");
                break;
            case arrow.down:
                this.handle_next_before("down");
                break;
            case arrow.right:
                break;
        }
    }
    handleFilterToggle = (selectType, selectName) => {
        var nextProps = { ...this.state }
        let saveFilterToggle = this.props.saveFilterToggle;
        saveFilterToggle[selectType][selectName] = !saveFilterToggle[selectType][selectName];
        if (saveFilterToggle[selectType]["filter"] === false) {
            saveFilterToggle[selectType]["input"] = false;
        } else {
            saveFilterToggle[selectType]["input"] = true;
        }
        //this.props.saveFilterToggleHandle(saveFilterToggle);
        filterData = { ...filterData, "saveFilterToggle": saveFilterToggle }
        nextProps = { ...nextProps, saveFilterToggle: saveFilterToggle }
        this.setState({ ...this.state, filterData })
        this.customComponentWillReceiveProps(nextProps, this.props);
    }

    oldFilterToggle = () => {
        this.props.toggleOldFilter();
    }
    handleApplyFilters = () => {
        if (filterData.clicked === "")
            alert("No changes detected in existing settings to Apply!")
        else {
            let new_props = { "selectedMetric": filterData.selectedMetric, "property": filterData.property, "breakup": filterData.breakup, "period": filterData.timeGran, "clicked": filterData.clicked, "include": filterData.include, "exclude": filterData.exclude, "transpose": filterData.transpose, "kpiMonitoring": filterData.kpiMonitoring, "crosstab_flag": filterData.crosstab_flag, "saveFilterToggle": filterData.saveFilterToggle, "sortOrder": filterData.sortOrder, "limit": filterData.limit }

            function removeNullValue(value) {
                if (typeof value === 'string') {
                    return value
                        .split(',')
                        .filter(item => item.trim() !== 'null') // Remove any instance of 'null'
                        .join(',') // Join remaining parts with commas
                        .replace(/,\s*,/g, ',') // Remove any extra commas left after filtering
                        .replace(/^,|,$/g, ''); // Remove leading or trailing commas if any
                }
                return value; // If value is not a string, return it as-is
            }

            if (this.props.pageName == 'pinboard' && this.props.editCompModal) {
                let params = { siteId: this.props.itemDetails.siteId, toolId: this.props.itemDetails.toolId }
                let data = JSON.parse(JSON.stringify(this.props.itemDetails.parameters));
                let labelShow;
                if (metricGlobal)
                    labelShow = getLabel(metricGlobal, this.state.selectedMetric, this.state.propertyDisp, this.state.SelectedBreakUpDisp, null, null, this.state.includeDisp, this.state.excludeDisp);
                if (filterData.clicked.includes('metric')) {
                    data.metric = data.selectedMetric = new_props.selectedMetric
                    data.metricText = labelShow.metricText
                }
                if (filterData.clicked.includes('property')) {
                    data.category = new_props.property
                    data.propertyText = labelShow.propertyText
                }
                if (filterData.clicked.includes('breakup')) {
                    const cleanedBreakup = new_props?.breakup.includes('null') ? removeNullValue(new_props?.breakup) : new_props?.breakup;
                    data.breakUp = cleanedBreakup === "empty" ? "" : cleanedBreakup;
                    data.breakupText = labelShow.breakupText === "empty" ? "" : labelShow.breakupText;
                }
                if (filterData.clicked.includes('include')) {
                    data.include = new_props.include == "empty" ? "" : new_props.include
                    data.includeText = labelShow.includeText == "empty" ? "" : labelShow.includeText
                }
                if (filterData.clicked.includes('exclude')) {
                    data.exclude = new_props.exclude == "empty" ? "" : new_props.exclude
                    data.excludeText = labelShow.excludeText == "empty" ? "" : labelShow.excludeText
                }
                if (filterData.clicked.includes('period')) {
                    data.chartType = new_props.period;
                    data.chartDispStyle = new_props.period;
                    data.period = new_props.period;
                }
                if (filterData.clicked.includes('outputType')) {
                    data.multiDim = new_props.crosstab_flag
                    data.transpose = new_props.transpose
                    data.kpiMonitoring = new_props.kpiMonitoring
                }
                if (data.chartCat.toLowerCase() == "report") {
                    if ((this.state.crosstab_flag === false || this.state.crosstab_flag === 'false') && this.state.property.includes(',')) {
                        let leftDim = this.state.property.split(',')
                        data.aboveDim = leftDim.pop()
                        data.leftDim = leftDim.toString()
                    } else {
                        data.aboveDim = ""
                        data.leftDim = this.state.property
                    }
                }
                let postData = {
                    'iddashboardConfiguration': this.props.itemDetails.iddashboardConfiguration,
                    'parameter': data
                }
                let that = this, dataSet = localStorage.Dataset ? JSON.parse(localStorage.Dataset) : [];
                CallAPI('POST', "/app/pinUpdate", postData, params, 0, function (response) {
                    if (response.status) {
                        alert(response.information);
                        jQuery('#editDashboardComponent').modal('toggle');
                    }
                    that.props.getComponentsAPI(that.props.dashboardID, dataSet, "Basic " + btoa(that.props.authData.userId + ":"));
                }, this.props.authData)
            } else {
                if (new_props.saveFilterToggle !== undefined) {
                    this.props.saveFilterToggleHandle(new_props.saveFilterToggle)
                }
                let response = {
                    include: filterData.includeDisp ? JSON.stringify(filterData.includeDisp) : JSON.stringify(getBreakupDisp(filterData.include, this.state.datasetDetails.alfred.property)),
                    exclude: filterData.excludeDisp ? JSON.stringify(filterData.excludeDisp) : JSON.stringify(getBreakupDisp(filterData.exclude, this.state.datasetDetails.alfred.property)),
                    filter: filterData.SelectedBreakUpDisp ? JSON.stringify(filterData.SelectedBreakUpDisp) : JSON.stringify(getBreakupDisp(filterData.breakup, this.state.datasetDetails.alfred.property)),
                    property: filterData.propertyDisp ? JSON.stringify(filterData.propertyDisp) : JSON.stringify(getPropertyDisp(filterData.property, this.state.datasetDetails.alfred.property))
                }
                let finalObj = handleParamsToSet(response, new_props, this)
                this.props.set_disp_objects({ ...finalObj, 'initialDataApiFlag': true })
                // screen_width <mobile_width ? this.closeClusterInsight():null

                document.getElementById('filter_go').setAttribute('style', 'background-color:green !important');
                document.getElementById('filter_go').innerHTML = "Filters Applied!";
                filterData = { "selectedMetric": "", "property": "", "breakup": "", "timeGran": "", "clicked": "", "include": "", "exclude": "", "sortOrder": "", "limit": "" }
            }
        }
    }

    render() {
        var that = this;
        if (jQuery(window).width() < mobile_width || jQuery(window).width() < tablet_width) {
            var filterDivWidth = { paddingTop: '0px', width: "100%", paddingBottom: "200px", zIndex: '1001' };
        } else var filterDivWidth = this.props.editCompModal ? { width: "495px", position: 'relative', right: '0px' } : { width: "387px", zIndex: '998' };

        var chartCatVar = this.props.pageName == "summary" || (this.props.itemDetails && this.props.itemDetails.componentType == 'Summary')
            ? "Block"
            : this.props.pageName == "report"
                ? "Table"
                : this.props.chartCat == "report"
                    ? "Table"
                    : this.props.chartCat;
        // filter conditions
        var filterConditions = this.props?.selectedMetric && (this.props?.pageName != "pinboard" || this.props?.editCompModal) ? validationInput(this.state?.property ? this.state?.property : this.props?.property, this.state?.selectedMetric ? this.state?.selectedMetric : this.props?.selectedMetric, this.state?.period ? this.state?.period : (this.props?.period ? this.props?.period : ""), chartCatVar ? chartCatVar.toLowerCase() : '', "all") : {};

        // Property case handled
        var up_down_buttons = <span>{"  "}<i className="fa fa-caret-up" id="property_top" style={{ marginLeft: '10px' }} onClick={this.handle_next_before.bind(this, "up")}></i>{"  "}<i className="fa fa-caret-down" id="property_down" onClick={this.handle_next_before.bind(this, 'down')} style={{ marginLeft: '5px' }}></i></span>;
        // var multiProperty = filterConditions.filter && filterConditions.filter.propertyMulti == "true" ? <i id="multi-property-enabled" className="float-right fa fa-plus-circle" onClick={this.property_multi_enable.bind(this)} style={{ cursor: 'pointer' }}></i> : null;
        var multiProperty = filterConditions?.filter && filterConditions?.filter?.propertyMulti == "true" ? <span>{" (You can select multiple)"}</span> : null;
        // var crossTabButton = <i id="crosstab-enabled" className="fa fa-plus-circle" onClick={this.property_multi_enable.bind(this)} style={{ cursor: 'pointer', marginLeft: '2%' }}></i>
        var crossTabButton = null
        propMulti = filterConditions?.filter && filterConditions?.filter?.propertyMulti == "true" ? true : false;

        let tempGranValue = null;
        if (that.state.period) {
            tempGranValue = that.props.TimeType != null ? that.props.TimeType.filter(function (innerData) { return innerData.value.toLowerCase() == that.state.period.toLowerCase() }) : []
        } else {
            tempGranValue = that.props.TimeType != null ? that.props.TimeType.filter(function (innerData) { return innerData.value.toLowerCase() == that.props.period.toLowerCase() }) : [];
        }
        tempGranValue = tempGranValue.length > 0 ? tempGranValue : { label: "Aggregate", value: "Aggregate" };

        // let outputTypeObj = this.state.transpose == "true" || this.state.transpose == true ? this.state.propertyDisp.length > 1 ? "normal" : "transpose" : (this.state.crosstab_flag === "false" || this.state.crosstab_flag === false ? "crosstab" : "normal");
        // Converted above code to below if-else statements
        let outputTypeObj = ""
        if ((this.state.transpose == "true" || this.state.transpose == true) && this.state.propertyDisp && this.state.propertyDisp.length <= 1) {
            outputTypeObj = "transpose"
        } else if ((this.state.kpiMonitoring == "true" || this.state.kpiMonitoring == true) && this.state.propertyDisp && this.state.propertyDisp.length <= 1) {
            outputTypeObj = "kpiMonitoring"
        } else if ((this.state.crosstab_flag === "false" || this.state.crosstab_flag === false) && this.state.propertyDisp && this.state.propertyDisp.length > 1) {
            outputTypeObj = "crosstab"
        } else outputTypeObj = "normal"

        var outputTypeValue = filterConditions?.filter && filterConditions?.filter?.outputType ? filterConditions?.filter?.outputType.filter(function (innerData) { return innerData.value == outputTypeObj }) : null;

        let metricOptions = []
        this.props.Metric.map(function (innerData) {
            if (innerData.isDisplay && innerData.isDisplay == "1") {
                if (that.state.selectedMetricDisp && that.state.selectedMetricDisp.findIndex(el => el.label === innerData.label) === -1) {
                    metricOptions.push(innerData);
                } else if (that.props.selectedMetricDisp && that.props.selectedMetricDisp.findIndex(el => el.label === innerData.label) === -1) {
                    metricOptions.push(innerData);
                }
            }
        });

        let sortOrderOptions = [{ "label": "Ascending", "value": "asc" }, { "label": "Descending", "value": "desc" }];
        let sortOrderValue = this.state.sortOrder ? this.state.sortOrder : this.props.sortOrder;
        let sortOrderObj = sortOrderOptions.filter(function (innerData) { return innerData.value === sortOrderValue });

        let limitOptions = [{ "label": "All", "value": "all" }, { "label": "5", "value": "5" }, { "label": "10", "value": "10" }, { "label": "20", "value": "20" }, { "label": "50", "value": "50" }];
        let limitValue = this.state.limit || this.state.limit === "" ? this.state.limit : this.props.limit;
        let limitObj = limitOptions.filter(function (innerData) { return innerData.value === limitValue });

        let evaluatedLimitCondition = ["summary", "pinboard"].indexOf(this.state.pageName) !== -1 || this.state.crosstab_flag === false || ["Aggregate", "aggregate", "null", "undefined", "", "empty"].indexOf(this.state.period ? this.state.period : this.props.period) === -1 || (this.state.pageName === "chart" && ["Column", "Bar", "Bullet", "Bar Bullet"].indexOf(chartCatVar) === -1);
        let isPinboardDimensionFilterVisible = this.state.pageName === "pinboard" && this.props.datasetDetails.userDBSetting[0].information && JSON.parse(this.props.datasetDetails.userDBSetting[0].information).displayDimensionFilter == false ? true : false; 
        var filterActualData = filterArray.map(function (selectType) {
            let tagTitle = "", tagCount = 0, liElements = null, elementId = "", tagInput = null, addKPI = true;
            let liElementsActions = { "toggle": false, remove: false, context: false, change: false };
            let tagSelectInfo = {};

            if (selectType == "outputType" || selectType == "timeGran") {
                if (filterConditions?.filter) {
                    if (selectType == "outputType" && (!filterConditions?.filter?.outputType || filterConditions?.filter?.outputType == "false"))
                        return
                    if (selectType == "timeGran" && (!filterConditions?.filter?.time || filterConditions?.filter?.time == "false"))
                        return
                } else {
                    return
                }
            }

            switch (selectType) {
                case "breakup":
                    tagTitle = "Filter";
                    tagCount = this.state.SelectedBreakUpDisp ? this.state.SelectedBreakUpDisp.length : this.props.SelectedBreakUpDisp.length;
                    liElements = this.state.SelectedBreakUpDisp ? this.state.SelectedBreakUpDisp : this.props.SelectedBreakUpDisp;
                    elementId = typeof this.state.breakup === "function" ? "breakupElement" : this.state.breakup && typeof this.state.breakup !== "function" ? this.state.breakup : (this.props.breakup && typeof this.props.breakup != "function" ? this.props.breakup : "breakupElement");
                    tagInput = <AsyncSelect placeholder="Filter by (Type to search)"
                        name="SelectedBreakUp"
                        ref="breakupFilter"
                        value={null}
                        onChange={this.filterHandle.bind(this, 'breakup')}
                        defaultOptions={true}
                        isMulti
                        loadOptions={this.selectLoad}
                        style={textMarginBottom}
                        cacheOptions={true}
                        noOptionsMessage={() => "Start typing to see options"}
                    />
                    break;
                case "property":
                    tagTitle = "Dimensions";
                    tagCount = this.state.propertyDisp ? this.state.propertyDisp.length : this.props.propertyDisp.length;
                    liElements = this.state.propertyDisp ? this.state.propertyDisp : this.props.propertyDisp;
                    elementId = this.state.property ? this.state.property : (this.props.property ? this.props.property : "propertyElement");
                    liElementsActions.context = false;
                    liElementsActions.toggle = true;
                    liElementsActions.change = true;
                    tagInput = <AsyncSelect placeholder="Select Dimension"
                        name="property"
                        ref="propertyFilter"
                        value={null}
                        defaultOptions={true}
                        onChange={this.propertyHandle.bind(this, 'property', 0)}
                        loadOptions={this.selectPropLoad}
                        isMulti={propMulti}
                        style={textMarginBottom}
                        cache={false}
                    />
                    tagSelectInfo = {
                        placeholder: "Select Dimensions (Type to search)",
                        name: "property",
                        ref: "propertyFilter",
                        defaultOptions: true,
                        onChange: this.propertyHandle.bind(this, 'property', 0),
                        loadOptions: this.selectPropLoad,
                        isMulti: false,
                        style: textMarginBottom,
                        cache: false
                    }
                    addKPI = filterConditions?.filter && filterConditions?.filter?.propertyMulti == "true" || screen_width < mobile_width ? true : false;
                    if (isPinboardDimensionFilterVisible ) return null;
                    break;
                case "metric":
                    tagTitle = "Metric";
                    tagCount = this.state.selectedMetricDisp ? this.state.selectedMetricDisp.length : this.props.selectedMetricDisp.length;
                    liElements = this.state.selectedMetricDisp ? this.state.selectedMetricDisp : this.props.selectedMetricDisp;
                    elementId = this.state.selectedMetric ? this.state.selectedMetric : (this.props.selectedMetric ? this.props.selectedMetric : "metricElement");
                    liElementsActions.context = true;
                    liElementsActions.toggle = true;
                    liElementsActions.change = true;

                    metricMulti = this.props.itemDetails && this.props.itemDetails.componentType == 'Summary'
                        ? false
                        : filterConditions?.filter && filterConditions?.filter?.metricMulti == "true"
                            ? true
                            : false;
                    tagInput = <Select placeholder="Select Metric"
                        name="metricValue"
                        value={null}
                        onChange={this.metricHandle.bind(this, 'metric', 0)}
                        options={metricOptions}
                        style={textMarginBottom}
                        isMulti={metricMulti}
                    />
                    tagSelectInfo = {
                        placeholder: "Select Metric",
                        name: "metricValue",
                        onChange: this.metricHandle.bind(this, 'metric', 0),
                        options: metricOptions,
                        style: textMarginBottom,
                        isMulti: false
                    }
                    //addKPI = metricMulti;
                    if (this.state.pageName == "pinboard" && !this.props.editCompModal) return null;
                    break;

                case "include":
                    tagTitle = "Include";
                    tagCount = this.state.includeDisp ? this.state.includeDisp.length : this.props.includeDisp.length;
                    liElements = this.state.includeDisp ? this.state.includeDisp : this.props.includeDisp;
                    elementId = this.state.include ? this.state.include : (this.props.include ? this.props.include : "includeElement");
                    tagInput = <AsyncSelect placeholder="For Include (Type to search)"
                        name="include"
                        ref="breakupInclude"
                        value={null}
                        onChange={this.filterHandle.bind(this, 'include')}
                        defaultOptions={true}
                        isMulti
                        loadOptions={this.selectIncludeLoad}
                        style={textMarginBottom}
                        cacheOptions={true}
                    />
                    break;
                case "exclude":
                    tagTitle = "Exclude";
                    tagCount = this.state.excludeDisp ? this.state.excludeDisp.length : this.props.excludeDisp.length;
                    liElements = this.state.excludeDisp ? this.state.excludeDisp : this.props.excludeDisp;
                    elementId = this.state.exclude ? this.state.exclude : (this.props.exclude ? this.props.exclude : "excludeElement");
                    tagInput = <AsyncSelect placeholder="For Exclude (Type to search)"
                        name="exclude"
                        ref="breakupExclude"
                        value={null}
                        onChange={this.filterHandle.bind(this, 'exclude')}
                        defaultOptions={true}
                        isMulti
                        loadOptions={this.selectExcludeLoad}
                        style={textMarginBottom}
                        cacheOptions={true}
                    />
                    break;
                case "outputType":
                    tagTitle = "Output Type";
                    tagCount = this.props.excludeDisp.length;
                    liElements = [];
                    elementId = outputTypeValue && outputTypeValue.length > 0 ? outputTypeValue.toString() : "outputTypeElement";
                    tagInput = <Select simpleValue placeholder="Transpose"
                        name="transpose"
                        value={outputTypeValue}
                        onChange={this.changeChart.bind(this, 'outputType')}
                        options={filterConditions?.filter?.outputType}
                        clearable={false}
                        style={textMarginBottom}
                    />
                    this.props.saveFilterToggle[selectType]['filter'] = true;
                    this.props.saveFilterToggle[selectType]['input'] = true;
                    break;
                case "timeGran":
                    tagTitle = "Time Granularity";
                    tagCount = this.props.excludeDisp.length;
                    liElements = [];
                    elementId = "timeGranElement";
                    tagInput = <Select simpleValue placeholder="Set Time Granularity"
                        name="timeGranularity"
                        value={tempGranValue}
                        onChange={this.changeChart.bind(this, 'time')}
                        options={this.props.TimeType != null ? this.props.TimeType : []}
                        clearable={false}
                        style={textMarginBottom}
                    />
                    this.props.saveFilterToggle[selectType]['filter'] = true;
                    this.props.saveFilterToggle[selectType]['input'] = true;
                    if (outputTypeValue && outputTypeValue.length > 0 && (outputTypeValue[0].value === 'transpose' || outputTypeValue[0].value == 'kpiMonitoring'))
                        return null
                    break;
                case "sortOrder":
                    tagTitle = "Sort Order";
                    liElements = [];
                    elementId = this.state.sortOrder ? this.state.sortOrder : (this.props.sortOrder ? this.props.sortOrder : "sortOrderElement");
                    tagInput = <Select placeholder="Select Sort Order"
                        name="sortOrder"
                        value={sortOrderObj}
                        onChange={this.handleSortOrder.bind(this, 'sortOrder')}
                        options={sortOrderOptions}
                        clearable={false}
                        style={textMarginBottom}
                    />
                    if (evaluatedLimitCondition) return null;
                    break;
                case "limit":
                    tagTitle = "Limit";
                    liElements = [];
                    elementId = this.state.limit ? this.state.limit : (this.props.limit ? this.props.limit : "limitElement");
                    tagInput = <Select placeholder="Select Limit"
                        name="limit"
                        value={limitObj}
                        onChange={this.handleLimit.bind(this, 'limit')}
                        options={limitOptions}
                        clearable={false}
                        style={textMarginBottom}
                    />
                    if (evaluatedLimitCondition) return null;
                    break;
            }

            liElementsActions.remove = true;

            liElements = liElements.map(function (innerData) {
                if (innerData.value == that.state.filterTagsToHandle) {
                    tagSelectInfo.value = innerData;
                    if (tagSelectInfo.name == "property") {
                        tagSelectInfo.onChange = that.propertyHandle.bind(this, 'property', 1)
                        return <AsyncSelect {...tagSelectInfo} className="mg-b-5" />
                    } else {
                        tagSelectInfo.onChange = that.metricHandle.bind(this, 'metric', 1)
                        return <Select {...tagSelectInfo} className="mg-b-5" />  ///
                    }
                } else {
                    return (
                        <li className="list-group-item list-group-item-action mg-b-5" key={innerData.value} id={innerData.value} style={{ backgroundColor: "#f5f5f5", color: "rgb(51,51,51)" }}>
                            <span className="pd-4" style={{ display: "inline-block" }}>{innerData.label}</span>
                            {liElementsActions.remove
                                ? <button className="btn btn-xs float-right pd-4 pd-l-10" onClick={that.toggleIndex.bind(this, selectType, innerData.value, "remove")}>
                                    <i data-feather='x' style={{ fontSize: "28px" }}></i>
                                </button>
                                : null}
                            {liElementsActions.context
                                ? <button className={`btn btn-xs float-right pd-4 pd-l-10 ${selectType}_moreOptions`} id={`${innerData.value}_more_options`}>
                                    <i data-feather='more-horizontal'></i>
                                </button>
                                : null}
                            {liElementsActions.toggle
                                ? <button className="btn btn-xs float-right pd-4 pd-l-10" id={`${innerData.value}_toggle_up`} onClick={that.toggleIndex.bind(this, selectType, innerData.value, "up")}>
                                    <i data-feather='chevron-up'></i>
                                </button>
                                : null}
                            {liElementsActions.toggle
                                ? <button className="btn btn-xs float-right pd-4 pd-l-10" id={`${innerData.value}_toogle_down`} onClick={that.toggleIndex.bind(this, selectType, innerData.value, "down")}>
                                    <i data-feather='chevron-down'></i>
                                </button>
                                : null}
                            {liElementsActions.change
                                ? <button className="btn btn-xs float-right pd-4" id={`${innerData.value}_change`} onClick={that.toggleIndex.bind(this, selectType, innerData.value, "change")}>
                                    <i data-feather='edit'></i>
                                </button>
                                : null}
                        </li>
                    )
                }
            });
            elementId = elementId ? (((elementId.replace(/ /g, "")).replace(/,/g, "_")).replace(/;/g, "_")).replace(/[^\w\s]/gi, "") : selectType;

            tagInput = this.state.saveFilterToggle && this.state.saveFilterToggle[selectType]['input'] ? tagInput : (this.props.saveFilterToggle[selectType]['input'] ? tagInput : null);

            return (
                <div className="card border-0 rounded-0" id={`filterContent_${selectType}_${elementId}`} key={`filterContent_${selectType}_${elementId}`}>
                    <div className='border-bottom' id={`filter_${selectType}`}>
                        <div className="card-header border-0" data-toggle="collapse" data-target={`#collapse_${selectType}`} aria-expanded={`${this.state.saveFilterToggle ? this.state.saveFilterToggle[selectType]['filter'] : this.props.saveFilterToggle[selectType]['filter']}`} aria-controls={`collapse_${selectType}`} style={{ cursor: "pointer" }} onClick={this.handleFilterToggle.bind(this, selectType, "filter")}>
                            <span>
                                {tagTitle}
                                {selectType && (selectType === "outputType" || selectType === "timeGran" || selectType === "sortOrder" || selectType === "limit") ? null : <span className="tx-11 tx-color-03 pd-l-5">{`(${tagCount})`}</span>}
                            </span>
                            <span className="float-right">
                                <i className="" data-feather="chevron-down"></i>
                            </span>
                        </div>
                        <div id={`collapse_${selectType}`} className={`collapse ${this.props.saveFilterToggle[selectType]['filter'] ? "show" : ""}`}>
                            <div className="card-body pd-y-0">
                                <ul className="list-group filterUlElements" id={`ulFilterDrag_${elementId}`} selecttype={`${selectType}`}>
                                    {liElements}
                                </ul>
                            </div>
                            <div className="card-footer border-0">
                                {/* {addKPI ? (tagInput ? tagInput : <button className="btn btn-sm btn-block btn-white" onClick={this.handleFilterToggle.bind(this,selectType,"input")}><i data-feather='plus' className="mg-r-5"></i>Add New</button>) : null} */}
                                {addKPI ? tagInput : null}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }.bind(this))

        let applyFilterButton = {
            "name": "Apply Filters!",
            "id": "filter_go",
            "event": this.handleApplyFilters
        }

        let rangeBasedForm = null, comparisonForm = null, compareMultipleForm = null;
        if (this.state.formattingForm.rangeBased.length == 0) {
            let rangeBasedTempForm = JSON.parse(JSON.stringify(this.formattingFormData))
            rangeBasedTempForm['deleteRule']['onClick'] = (e) => this.handleDeleteRule(e, 'rangeBased')
            formattingFormObject['rangeBased'].push(rangeBasedTempForm)
        }
        if (this.state.formattingForm.rangeBased.length > 0) {
            rangeBasedForm = <Formv2 label_array={this.state.formattingForm['rangeBased']} handleForm={(e) => this.onChangeHandle(e, 'rangeBased')} handle_form_drop_down={(e) => this.onChangeHandle(e, 'rangeBased')} conditionalFormatting={true} formattingType='rangeBased' />
        }
        if (this.state.formattingForm.comparison.length == 0) {
            let comparisonTempForm = JSON.parse(JSON.stringify(this.formattingFormData))
            comparisonTempForm['operator']['options'].splice(7, 1)
            comparisonTempForm['compareParam']['type'] = 'dropdown'
            comparisonTempForm['value']['type'] = 'hide'
            comparisonTempForm['deleteRule']['onClick'] = (e) => this.handleDeleteRule(e, 'comparison')
            formattingFormObject['comparison'].push(comparisonTempForm)
        }
        if (this.state.formattingForm.comparison.length > 0) {
            comparisonForm = <Formv2 label_array={this.state.formattingForm['comparison']} handleForm={(e) => this.onChangeHandle(e, 'comparison')} handle_form_drop_down={(e) => this.onChangeHandle(e, 'comparison')} conditionalFormatting={true} formattingType='comparison' />
        }
        if (this.state.formattingForm.compareMultiple.length == 0) {
            let compareMultipleTempForm = JSON.parse(JSON.stringify(this.formattingFormData))
            compareMultipleTempForm['operator']['options'].splice(5, 3)
            compareMultipleTempForm['compareParam']['type'] = 'dropdown'
            compareMultipleTempForm['compareParam']['label'] = 'Metrics benchmark'
            compareMultipleTempForm['compareParam']['multiple'] = true
            compareMultipleTempForm['value']['type'] = 'hide'
            compareMultipleTempForm['deleteRule']['onClick'] = (e) => this.handleDeleteRule(e, 'compareMultiple')
            formattingFormObject['compareMultiple'].push(compareMultipleTempForm)
        }
        if (this.state.formattingForm.compareMultiple.length > 0) {
            compareMultipleForm = <Formv2 label_array={this.state.formattingForm['compareMultiple']} handleForm={(e) => this.onChangeHandle(e, 'compareMultiple')} handle_form_drop_down={(e) => this.onChangeHandle(e, 'compareMultiple')} conditionalFormatting={true} formattingType='compareMultiple' />
        }
        let leftButtons = [{ 'name': 'Add rule', 'action': (e) => this.handleAddRule(e), 'buttonClass': 'success' }, { 'name': 'Delete all', 'action': (e) => this.handleDeleteRule(e), 'buttonClass': 'danger mr-auto' }]
        let modalConfig = {
            "rangeBasedModal": {
                "id": "rangeBasedModal", "form_id": "rangeBasedForm", "form_name": "rangeBased", "title": this.state.condFormatModalTitle, "body": rangeBasedForm, "button_name": 'Save', 'leftButtonDisplay': true, 'leftButtons': leftButtons, "formKey": `rangeBased_${Math.floor(Math.random() * 10)}`, "display": true
            },
            "comparisonModal": {
                "id": "comparisonModal", "form_id": "comparisonForm", "form_name": "comparison", "title": this.state.condFormatModalTitle, "body": comparisonForm, "button_name": 'Save', 'leftButtonDisplay': true, 'leftButtons': leftButtons, "formKey": `comparison_${Math.floor(Math.random() * 10)}`, "display": true
            },
            "compareMultipleModal": {
                "id": "compareMultipleModal", "form_id": "compareMultipleForm", "form_name": "compareMultiple", "title": this.state.condFormatModalTitle, "body": compareMultipleForm, "button_name": 'Save', 'leftButtonDisplay': true, 'leftButtons': leftButtons, "formKey": `compareMultiple_${Math.floor(Math.random() * 10)}`, "display": true
            }
        }

        let rangeBasedModal = <ModalComponent modalConfig={modalConfig["rangeBasedModal"]} action={(e) => this.handleFormattingModal(e)} conditionalFormatting={true} />
        let comparisonModal = <ModalComponent modalConfig={modalConfig["comparisonModal"]} action={(e) => this.handleFormattingModal(e)} conditionalFormatting={true} />
        let compareMultipleModal = <ModalComponent modalConfig={modalConfig["compareMultipleModal"]} action={(e) => this.handleFormattingModal(e)} conditionalFormatting={true} />

        return (
            <div className="pd-t-0">
                <div className={`${this.props.editCompModal ? '' : 'sidebar sidebar-fixed insight-formatting'}`} id='FilterDiv' style={filterDivWidth}>
                    {!this.props.editCompModal
                        ? <div className="card tx-16 pd-x-20 pd-t-10 pd-b-10 bd-l-0 bd-r-0" style={{ borderRadius: "0px", borderTop: '0px' }}>
                            <div style={{ overflow: "auto", fontWeight: 500, textTransform: 'uppercase' }}>
                                Filter Settings
                                { /*COMMENTED OLD FILTER BUTTON BECAUSE OF NO FREQ USE*/}
                                {/* <div className="d-inline-flex mg-b-0 form-group custom-control custom-switch mg-l-100">
                                <input type="checkbox" className="custom-control-input" id="dateView" checked={this.state.oldFilter} onChange={this.oldFilterToggle}/>
                                <label className="custom-control-label tx-13" htmlFor="dateView">Old Filter</label>
                            </div> */}
                                <a href="javascript:void(0)" className="close float-right" onClick={this.closeClusterInsight}><i data-feather='x'></i></a>
                            </div>
                        </div>
                        : null}
                    {/* <div className="card tx-16 pd-x-20 pd-t-10 pd-b-9 bd-l-0 bd-r-0" style={{ borderRadius: "0px", borderTop: '0px' }}>
                        <ButtonComponent buttonData={applyFilterButton} />
                    </div> */}
                    <div className="insight-overflow">
                        {filterActualData}
                    </div>
                    <div className="card tx-16 pd-x-20 pd-t-10 pd-b-9 bd-l-0 bd-r-0" style={{ borderRadius: "0px", borderTop: '0px' }}>
                        <ButtonComponent buttonData={applyFilterButton} />
                    </div>
                </div>
                {rangeBasedModal}
                {comparisonModal}
                {compareMultipleModal}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allProperty: state.dataSet.allProperty ? state.dataSet.allProperty[state.dataSet.dataSet.toolId] : [],
        allDashboards: state.dataSet.allDashboards,
        filter: state.dataSet.filter,
        geoLocationDimesnionArray: state.dataSet.alfred.location, //extracting location array for map chart
        granularity: state.dataSet.summarizationDetails[0].granularity,
        dashboardConfigDates: state.dataSet.dashboard,
        saveFilterToggle: state.dataSet.saveFilterToggle ? state.dataSet.saveFilterToggle : { "property": { "filter": true, "input": true }, "metric": { "filter": true, "input": true }, "breakup": { "filter": false, "input": true }, "include": { "filter": false, "input": true }, "exclude": { "filter": false, "input": true }, "timeGran": { "filter": true, "input": true }, "outputType": { "filter": true, "input": true }, "sortOrder": { "filter": false, "input": true }, "limit": { "filter": false, "input": true } },
        oldFilter: state.dataSet.oldFilter || false
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        removeFilter, set_property_metric_breakup, remove_property_metric_breakup, get_property_metric_breakup, set_disp_objects, setTableActions, handle_transpose_table, saveFilterToggleHandle, toggleOldFilter
    }, dispatch)
}
function checkInArray(array, newData) {
    var check = false;
    array.map(function (innerData, index) {
        if (innerData.value == newData.value)
            check = true;
    })
    return check;
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterComponent)

